export default ({ address1, address2, city, zipCode }: any) => {
    return `${address1}, ${address2 ? `${address2}, ` : ''}${city}, ${zipCode}`;
};
